import { getURL } from '../services/fetchUtilities';
import { ServiceRegionType } from '../type';

export const AppURL = {
    doverunnerHelpCenter: `${process.env.REACT_APP_DOVERUNNER_API}/zendesk/sso-login`,
    useQueryAllPackagesLink: 'https://helpcenter.appsealing.com/hc/en-us/articles/6310295171225-How-to-submit-QUERY-ALL-PACKAGES-permission-usage-form-at-Google-Play-Console',
    beforeSealingLink: 'https://doverunner.com/docs/mobile-app-security/android/android-security/#security-guide',
    dataSealingLink: 'https://doverunner.com/docs/mobile-app-security/android/android-datasealing/',
    helpCenter: 'https://support.doverunner.com/hc/',
    privacyterms: 'https://www.appsealing.com/privacy-and-terms',
    privacyterms_kr: 'https://www.appsealing.com/kr/privacy-and-terms-2',
    slackwebhook: 'https://slack.com/apps/A0F7XDUAZ-incoming-webhooks',
    verifyrecaptch: 'https://www.google.com/recaptcha/api/siteverify',
    clitool: '/assetsvc/cli_tool/AppSealing_CI_Integration_Tool_latest.zip',
    emailValidate: 'https://mkt.appsealing.com/l/1057633/2024-06-14/3sy2cl',
    salesforce: 'https://mkt.appsealing.com/l/1057633/2024-02-13/3snhvd',
    oktaLogin: '/covault/gw/oauth/okta/login',
    oktaCallback: '/oktasvc/callback',
    doverunner: `${process.env.REACT_APP_DOVERUNNER_URL}`,
    doverunnerLogin: `${process.env.REACT_APP_DOVERUNNER_URL}/login`,
    doverunnerDashboard: `${process.env.REACT_APP_DOVERUNNER_URL}/dashboard`,
    doverunnerProfile: `${process.env.REACT_APP_DOVERUNNER_URL}/account/profile`,
    doverunnerIntegration: `${process.env.REACT_APP_DOVERUNNER_URL}/integrate/agreement?product=appsealing`,
    doverunnerLogout: `${process.env.REACT_APP_DOVERUNNER_URL}/logout`,
    appSecurity: `${process.env.REACT_APP_APPSECURITY_URL}`,
    contentSecurity: `${process.env.REACT_APP_CONTENTSECURITY_URL}`,
    billingDetails: `${process.env.REACT_APP_DOVERUNNER_URL}/billing/information`,
    userManagement: `${process.env.REACT_APP_DOVERUNNER_URL}/users/management`,

    terms: 'https://doverunner.com/terms-and-conditions',
    terms_kr: 'https://doverunner.com/kr/terms-and-conditions',
    privacy: 'https://doverunner.com/privacy-policy',
    privacy_kr: 'https://doverunner.com/kr/privacy-policy',

    login: '/usersvc/login',
    logout: '/usersvc/logout',
    signup: '/usersvc/signup',
    resetPwd: '/userssvc/change-password/link',
    resetNewPwd: '/userssvc/change-password',
    signupaws: '/usersvc/signupaws',
    signupmember: '/usersvc/signupMember',
    signupmemberValidate: '/usersvc/signupMember-validate',
    ssoLogin: '/usersvc/zendesk/ssoLogin',
    reactivation: '/usersvc/reactivation',
    agreeinvitemember: '/usersvc/agreeInviteMember',

    profile: '/usersvc/profile',
    userssvc: '/userssvc',
    activateaccountmember: '/userssvc/active',
    deactivateaccountmember: '/usersvc/ownerDeactivateUser',
    inviteaccountmember: '/usersvc/inviteAccountMember',
    getaccountmemberlist: '/usersvc/getAccountMemberList',
    editaccountmembernote: '/usersvc/editAccountMemberNote',
    getmemberinvitehistory: '/usersvc/MemberInviteHistory',
    removeaccountmember: '/userssvc',
    preference: '/usersvc/preference',
    changePwd: '/usersvc/changepwd',
    mfa: '/mfasvc',
    mfaValidate: '/mfasvc/validate',
    companySecurity: '/companiessvc/',

    city: '/commonsvc/city',
    state: '/commonsvc/state',
    country: '/commonsvc/country',
    timezone: '/commonsvc/timezone',
    appcategory: '/commonsvc/appCategory',
    notifycheck: '/accountsvc/notifyCheck',
    changeserviceregion: '/accountsvc/changeServiceRegion',

    information: '/accountsvc/information',
    contactus: '/accountsvc/contactus',

    plan: '/accountsvc/plan',
    payment: '/accountsvc/payment',
    changeplan: '/authsvc/changePlan',
    privacypolicy: '/assetsvc/AppSealing+Privacy+Policy.txt',
    termsofservice: '/assetsvc/AppSealing+Terms+of+Service.txt',

    txhistory: '/accountsvc/txhistory',
    getcreditinfo: '/promotionsvc/loadCreditInformation',
    redeempromocode: '/promotionsvc/redeemPromotionCode',

    getpublickey: '/invoicesvc/Stripe/getPublicKey',
    getsetupintent: '/invoicesvc/Stripe/getSetupIntent',
    savepaymentinfo: '/invoicesvc/Stripe/savePaymentInfo',
    removepginfo: '/accountsvc/removePgInfo',

    invoicelist: '/invoicesvc/information',
    refundrequest: '/invoicesvc/Stripe/globalRefundRequest',
    downloadinvoice: '/invoicesvc/ver2/downloadInvoicePdf',

    sendusernotification: '/webhooksvc/salesMetric',
    sendfeedback: '/webhooksvc/giveFeedback',
    webhookstatus: '/webhooksvc/webhookstatus',
    updatewebhook: '/webhooksvc/insertwebhookurl',
    subscribetrigger: '/webhooksvc/subscribeTrigger',
    unsubscribetrigger: '/webhooksvc/unsubscribeTrigger',

    authoriseuser: '/authsvc/AuthValidOwner',
    requestwithdrawal: '/accountsvc/requestWithdrawal',

    getAccountHash: '/asiasvc/getAccountHash',
    getReleasedVersionInfo: '/asiasvc/getReleasedVersions',
    getReleaseNote: '/asiasvc/getAiSMReleaseNote',
    getLatestVersionInfo: '/asiasvc/getLatestVersionInfo',
    getDownloadSdkUrlLauncher: '/asiasvc/getLauncherDownloadUrl',
    getDownloadSdkUrl: '/asiasvc/getDownloadSdkUrl',
    getUserGuideUrl: '/asiasvc/getDownloadManualUrl',
    getArm64Guide: {
        en_US: 'https://appsealing-adc-site.s3.ap-northeast-1.amazonaws.com/dev/iOS/AiSM_arm64_Installation_Troubleshooting.pdf',
        kr_KR: 'https://appsealing-adc-site.s3.ap-northeast-1.amazonaws.com/dev/iOS/AiSM_arm64_설치문제해결.pdf',
    },

    preset: '/presetsvc/',
    sealingPreset: '/sealingPresetsvc/',

    userlogs: '/userlogssvc',

    groups: '/groupssvc',

    application: '/appssvc',
    threatNotification: '/threatnotificationsvc',
    threatNotificationConditions: '/threatnotificationsvc/support',
    slack: '/slackwebhooksvc',
};

export const RegionalURL: any = {
    totdata: '/datasvc/totdata',
    iostotdata: '/datasvc/ios/totdata',

    multidimension: '/datasvc/hacking//multidimension',
    multidimensiondaily: '/datasvc/hacking/multidimensionDaily',
    hackingattemptssubcategories: '/datasvc/hackingAttemptsSubCategories',
    iosmultidimension: '/datasvc/ios/hacking/multidimension',
    iosmultidimensiondaily: '/datasvc/ios/hacking/multidimensionDaily',
    hackinglogstream: '/datasvc/hackingLogStream',

    hackingauditstream: '/datasvc/android/hackingAuditStream',
    hackingauditlogstream: '/datasvc/hackingLogStreamWithoutAid',
    ioshackingauditstream: '/datasvc/ios/hackingAuditStream',
    ioshackingauditlogstream: '/datasvc/ios/hackingLogStreamWithoutDeviceUuid',

    getandroidpackages: '/datasvc/auPkg',
    getiospackages: '/datasvc/ios/getBundleIdList',
    getdaud: '/datasvc/daud',
    getiosdaud: '/datasvc/ios/daud',
    getmaud: '/datasvc/maud',
    getiosmaud: '/datasvc/ios/maud',

    viewlog: '/sealingsvc/viewlog',
    sealinginfo: '/sealingsvc/information',
    viewlogpath: '/sealingsvc/viewlogpath',
    serviceables: '/sealingsvc/serviceables',
    sealingavailable: '/sealingsvc/sealingAvailable',
    uploadkeystore: '/sealingsvc/uploadKeystore',
    deleteKeystore: '/sealingsvc/deleteKeystore',
    hybridserviceables: '/sealingsvc/hybrid/serviceables',
    checksealingstatus: '/sealingsvc/checkSealingStatus',
    selectkeystoreinfo: '/sealingsvc/selectKeystoreInfo',

    requestsealing: '/sealinghybridsvc/request_sealing',
    sealingHistory: '/sealinghybridsvc/html5/sealingHistory',
    requesthtmlsealing: '/sealinghybridsvc/html5/requestSealing',
    checkhybridsealingstatus: '/sealinghybridsvc/html5/sealingStatus',
    downloadsealedapk: '/sealinghybridsvc/apkfile/downloadSealedAPK',
    downloadsealedsignedapp: '/sealinghybridsvc/downloadSealedSignedApp',
    downloadSealedFile: '/sealinghybridsvc/html5/downloadSealedFile',

    application: '/appsvc',
    applist: '/appsvc/appList',
    addproject: '/appsvc/ios/addProject',
    getCredential: '/appsvc/ios/getCredential',
    projectlist: '/appsvc/ios/projectList',
    nativesdkinfo: '/appsvc/ios/nativeSdkInfo',
    hybridsdkinfo: '/appsvc/ios/hybridSdkInfo',
    getselectivelist: '/appsvc/getSelectiveList',
    getselectivedexlist: '/appsvc/getSelectiveDexClassPackageList',
    updateprojectname: '/appsvc/ios/updateProjectName',
    updatebundleidprefix: '/appssvc/ios/change-bundle-id',

    updateIosAppName: '/appssvc/ios/change-app-name',
    updateAndroidAppName: '/appssvc/android/change-app-name',

    addselectivedex: '/appsvc/addSelectiveDexClassPackage',
    removeselectivedex: '/appsvc/removeSelectiveDexClassPackage',

    buildiosnative: '/sdksvc/ios/sdkBuild',
    buildioshybrid: '/sdksvc/ios/hybridSdkBuild',
    checkbuildioshybrid: '/sdksvc/ios/checkBuildHybridSdkStatus',

    toggleservice: '/authsvc/serviceOnOff',
    toggleadvservice: '/authsvc/toggleSingleAppAdvSvcOnOff',
    requesttransfer: '/pkgmangersvc/reqTransfer',
    getworkingitemlist: '/blacklistsvc/getWorkingList',
    addworkingitem: '/blacklistsvc/addWorkingItem',
    removeworkingitem: '/blacklistsvc/delWorkingItem',
    getpublishedlist: '/blacklistsvc/getLatestPublishedList',
    publishworkingcopy: '/blacklistsvc/publishWorkingCopy',
    toggleoffpublished: '/blacklistsvc/toggleOffPublished',
    stopotaserviceupdate: '/blacklistsvc/stopOtaServiceUpdate',

    requestDownloadsealedsignedapp: '/sealinghybridsvc/requestDownloadSealedSignedApp',
    checkDownloadsealedsignedapp: '/sealinghybridsvc/checkDownloadSealedSignedApp',
    downloadPreparedsealedsignedapp: '/sealinghybridsvc/downloadPreparedsealedsignedapp',
};

export const getRegionalURL = (regionalURL: string, region: ServiceRegionType) => {
    let url = '',
        routeKey = region === 'AWS_MUMBAI' ? '-in' : region === 'AWS_JAKARTA' ? '-jakarta' : '';

    let list = regionalURL.split('/');
    list[1] = list[1] + routeKey;
    url = list.join('/');

    return getURL(url);
};
